<template>
    <div>
        <div>
            <div
                v-if="gamesStore[type].ready && providerStore.ready"
                class="flex flex-col [--header-offset:50px] lg:[--header-offset:90px]"
                :class="'h-[calc(100vh-var(--offset))] supports-[height:100dvh]:h-[calc(100dvh-var(--offset))]'"
                :style="`--offset: calc(${(mainStore.redeemBannerHeight) + (mainStore.downloadBarHeight)}px + var(--header-offset) + 50px);`"
            >
                <div class="relative shrink-0">
                    <div class="flex items-center game-search-bg px-[5px] py-[5px]">
                        <div class="relative" style="width: calc(100% - 60px)">
                            <DForm  novalidate>
                                <div class="search_box">
                                    <input v-model="game_input" @input="searchBuffer()" class="h-[35px] pl-[40px] pr-[10px] bg-[var(--game-search-input-color)] search_input_text_color focus:outline-none w-full rounded-[5px]" autocapitalize="off">
                                    <Icon iconClass="icon-search search_icon"></Icon>
                                    <img v-if="game_input" class="clean_search" @click="game_input = ''; handleSearch()" src="/img/icons/close_2.svg" alt="close_2">
                                </div>
                            </DForm>
                        </div>
                        <div class="flex items-center ml-[15px] w-[60px]">
                            <button @click="gameView = 'grid'" aria-label="Game View" type="button" class="game_view_button mr-[10px]" :class="gameView == 'grid' ? 'active' : ''">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                                    <path d="M7.292,0H1.458A1.459,1.459,0,0,0,0,1.458V7.292A1.459,1.459,0,0,0,1.458,8.75H7.292A1.459,1.459,0,0,0,8.75,7.292V1.458A1.459,1.459,0,0,0,7.292,0Z" fill="currentColor" />
                                    <path d="M7.292,9H1.458A1.459,1.459,0,0,0,0,10.458v5.833A1.459,1.459,0,0,0,1.458,17.75H7.292A1.459,1.459,0,0,0,8.75,16.292V10.458A1.459,1.459,0,0,0,7.292,9Z" transform="translate(0 4.125)" fill="currentColor" />
                                    <path d="M7.292,18H1.458A1.459,1.459,0,0,0,0,19.458v5.833A1.459,1.459,0,0,0,1.458,26.75H7.292A1.459,1.459,0,0,0,8.75,25.292V19.458A1.459,1.459,0,0,0,7.292,18Z" transform="translate(0 8.25)" fill="currentColor" />
                                    <path d="M16.292,0H10.458A1.459,1.459,0,0,0,9,1.458V7.292A1.459,1.459,0,0,0,10.458,8.75h5.833A1.459,1.459,0,0,0,17.75,7.292V1.458A1.459,1.459,0,0,0,16.292,0Z" transform="translate(4.125)" fill="currentColor" />
                                    <path d="M16.292,9H10.458A1.459,1.459,0,0,0,9,10.458v5.833a1.459,1.459,0,0,0,1.458,1.458h5.833a1.459,1.459,0,0,0,1.458-1.458V10.458A1.459,1.459,0,0,0,16.292,9Z" transform="translate(4.125 4.125)" fill="currentColor" />
                                    <path d="M16.292,18H10.458A1.459,1.459,0,0,0,9,19.458v5.833a1.459,1.459,0,0,0,1.458,1.458h5.833a1.459,1.459,0,0,0,1.458-1.458V19.458A1.459,1.459,0,0,0,16.292,18Z" transform="translate(4.125 8.25)" fill="currentColor" />
                                    <path d="M25.292,0H19.458A1.459,1.459,0,0,0,18,1.458V7.292A1.459,1.459,0,0,0,19.458,8.75h5.833A1.459,1.459,0,0,0,26.75,7.292V1.458A1.459,1.459,0,0,0,25.292,0Z" transform="translate(8.25)" fill="currentColor" />
                                    <path d="M25.292,9H19.458A1.459,1.459,0,0,0,18,10.458v5.833a1.459,1.459,0,0,0,1.458,1.458h5.833a1.459,1.459,0,0,0,1.458-1.458V10.458A1.459,1.459,0,0,0,25.292,9Z" transform="translate(8.25 4.125)" fill="currentColor" />
                                    <path d="M25.292,18H19.458A1.459,1.459,0,0,0,18,19.458v5.833a1.459,1.459,0,0,0,1.458,1.458h5.833a1.459,1.459,0,0,0,1.458-1.458V19.458A1.459,1.459,0,0,0,25.292,18Z" transform="translate(8.25 8.25)" fill="currentColor" />
                                </svg>
                            </button>
                            <button @click="gameView = 'list'" aria-label="Game View" type="button" class="game_view_button" :class="gameView == 'list' ? 'active' : ''">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.147 35">
                                    <g transform="translate(0 -73.861)">
                                        <g transform="translate(0 73.861)">
                                            <g transform="translate(0 0)">
                                                <path d="M4.334,73.862a4.795,4.795,0,0,0,0,9.545,4.795,4.795,0,0,0,0-9.545Zm0,12.727a4.795,4.795,0,0,0,0,9.546,4.795,4.795,0,0,0,0-9.546Zm0,12.727a4.795,4.795,0,0,0,0,9.545,4.795,4.795,0,0,0,0-9.545Zm11.558-17.5H30.258a3.2,3.2,0,0,0,0-6.364H15.892a3.2,3.2,0,0,0,0,6.364ZM30.258,88.18H15.892a3.2,3.2,0,0,0,0,6.364H30.258a3.2,3.2,0,0,0,0-6.364Zm0,12.727H15.892a3.2,3.2,0,0,0,0,6.364H30.258a3.2,3.2,0,0,0,0-6.364Z" transform="translate(0 -73.862)" fill="currentColor"/>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div v-if="type !== 'iblotto'" class="bg-[var(--game-tab-menu-bg)] p-[5px]">
                        <div class="flex items-center overflow-x-auto none-scrollbar">
                            <button @click="selectedCategory = 1; game_input = ''" type="button" class="game_tab_btn" :class="selectedCategory == 1 ? 'active' : ''" :aria-label="$t('all_games')">{{$t("all_games")}}</button>
                            <button @click="selectedCategory = 2; game_input = ''" type="button" class="game_tab_btn" :class="selectedCategory == 2 ? 'active' : ''" :aria-label="$t('hot_games')">{{$t("hot_games")}}</button>
                            <button @click="selectedCategory = 3; game_input = ''" type="button" class="game_tab_btn" :class="selectedCategory == 3 ? 'active' : ''" :aria-label="$t('new_games')">{{$t("new_games")}}</button>
                            <button @click="selectedCategory = 4; game_input = ''" type="button" class="game_tab_btn" :class="selectedCategory == 4 ? 'active' : ''" :aria-label="$t('favourite_games')">{{$t("favourite_games")}}</button>
                        </div>
                    </div>
                </div>
                <div v-if="gamesStore[type].ready" class=" flex-grow overflow-hidden relative bg-[var(--game-tab-menu-bg)]">
                    <div v-if="mainStore.loadingGame" class="loading_bg">
                        <Spinner></Spinner>
                    </div>
                    <div class="flex h-full">
                        <div class="relative" style="height: calc(100% - 40px);">
                            <div class="w-[65px] h-[20px] bg-[var(--sidebar-btn-arrow-bg)] flex items-center justify-center">
                                <svg class="w-[15px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                    <path class="game_tab_arrow" d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </div>
                            <div class="w-[65px] h-full overflow-y-auto none-scrollbar relative" ref="providerScroll">
                                <template v-for="(i, index) in gamesStore[type].list" :key="index">
                                    <button v-if="index != 'all' && index != 'new' && index != 'hot'" :aria-label="index" @click="selectProviderTab(i, index)" type="button" class="sidebar_button relative"  :class="index.toUpperCase() == selected_index_tab ? 'active' : ''">
                                        <template v-if="getMaintenanceStatus(index)">
                                            <img class="maintenance-tag" draggable="false" src="/img/icons/warning.webp" alt="warning" />
                                        </template>
                                        <template v-else>
                                            <template v-if="providerStore.meta[type][index] && [providerStore.meta[type][index].show_hot, providerStore.meta[type][index].show_new].includes(1) && type !== 'iblotto'">
                                                <div v-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_hot == 1" class="provider_hot_tag_mobile">
                                                    <img class="w-[20px] mx-auto" :src="$resolveUrl(`{d}web_asset/hot.png`)" alt="hot">
                                                </div>
                                                <img v-else-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_new == 1" class="app_tag select-none" draggable="false" src="/img/icons/new_tag.webp" alt="new_tag" />
                                                                                                                                        </template>
                                        </template>
                                        <div class="sidebar_button_content">
                                            <img :src="getProviderLogo(index)" :alt="`provider_${index}`">
                                            <div class="text w-[50px] text-[10px] text-center pt-1 uppercase" 
                                                :class="type !== 'iblotto' ? 'text truncate' : 'text-iblotto'">
                                            {{ getProviderName(index)}}
                                            </div>
                                        </div>
                                        <img v-if="providerStore.meta[type][index] && providerStore.meta[type][index].show_vpn == 1" class="provider_vpn_tag select-none" draggable="false" src="/img/icons/new_vpn.webp" alt="vpn_tag"  :style="getVpnStyle"/>                                   
                                     </button>
                                    <template v-if="ratioInfoDisplay">
                                        <div v-for="(value, key) in providerStore.data[type]" :key="key" class="relative">
                                        <div v-if="value.providerName.toUpperCase() == index && value.ratio" class="ratio-info" :class="`${index.toUpperCase() == selected_index_tab ? 'active' : 'ratio-info-inactive'}`">{{dashboardStore.data.currency}} {{value.ratio}} = 1</div>
                                    </div>
                                    </template>              
                                </template>
                                <button v-for="i in providerListAPP" :aria-label="i.providerName" :key="`${i.providerName}_app`" @click="openAPP(i)" type="button" class="sidebar_button">
                                    <div class="sidebar_button_content">
                                        <img class="app_tag_mobile select-none" draggable="false" src="/img/icons/app_tag.webp" alt="app_tag" />
                                        <img :src="getProviderLogo(i.providerName)" :alt="`provider_${i.providerName}`">
                                        <div class="text uppercase truncate">{{i.providerName}}</div>
                                    </div>
                                </button>
                            </div>
                            <div class="w-[65px] h-[20px] bg-[var(--sidebar-btn-arrow-bg)] flex items-center justify-center">
                                <svg class="w-[15px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                <path class="game_tab_arrow" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </div>
                        </div>
                        <div class="overflow-y-auto bg-[var(--game-container-bg)] p-[5px] none-scrollbar" ref="gameList" style="width: calc(100% - 55px);" @scroll="onScroll">
                            <div ref="current_game_list_container">
                                <div v-if="currentGameList.length > 0" class="grid items-start" :class="gameView == 'grid' ? (type == 'iblotto' ? 'grid-cols-2 md:grid-cols-4 gap-2' : 'grid-cols-3 md:grid-cols-5') : 'grid-cols-1'" :key="gameListKey">
                                    <template v-for="g in currentGameList" :key="g.game_id">
                                        <div v-if="type == 'iblotto'" class="lottery-card-container" ref="gameRefs">
                                            <div class="lottery-card-header">
                                                <div class="lottery-icon-circle" :style="`background-image: url(${$resolveUrl(`{d}flags/${g.country}.webp`)})`"></div>
                                                <div class="lottery-title">
                                                    {{(g.game_lang && g.game_lang[mainStore.lang]) ? g.game_lang[mainStore.lang] : g.game_name}}
                                                </div>
                                            </div>

                                            <div class="lottery-card-body">
                                                <template v-if="lotteryCountdowns[g.game_id]">
                                                    <div class="lottery-timer-display status-open">
                                                        {{ lotteryCountdowns[g.game_id].status === 'end' ? lotteryCountdowns[g.game_id].time : '&nbsp;' }}
                                                    </div>
                                                    
                                                    <div class="lottery-schedule-info">
                                                        <div class="info-circle-icon">i</div>
                                                        <span>{{ $t("open_at") }} {{ lotteryCountdowns[g.game_id]?.nextOpen }}</span>
                                                    </div>
                                                </template>

                                                <div class="lottery-action-area">
                                                    <button v-if="lotteryCountdowns[g.game_id]?.status === 'end'" class="btn-bet" @click="playGame(g)">
                                                        {{ $t("bet") }}
                                                    </button>
                                                    <button v-else class="btn-registration-closed" disabled>
                                                        {{ $t("registration_closed") }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <button v-else :aria-label="(g.game_lang && g.game_lang[mainStore.lang]) ? g.game_lang[mainStore.lang] : g.game_name" 
                                                ref="gameRefs" type="button" class="tab_game" @click="playGame(g)">
                                            
                                            <div class="relative rounded-md overflow-hidden">
                                                <div class="mobile_game placeholder"></div>
                                                <div class="game_img" :style="`background-image: url(${checkImg(g.img)})`">
                                                    <div class="game_img_aspect_ratio"></div>
                                                </div>
                                                <!-- <div class="provider_corner_badge">
                                                    <img class="provider_corner_badge_img" :src="getProviderLogoWhite(g.provider_name)" :alt="`provider_${g.provider_name}`" loading="lazy">
                                                </div> -->

                                                <div v-if="gameView === 'grid' && isIBL">
                                                    <template v-if="lotteryCountdowns[g.game_id]">
                                                        <div v-if="lotteryCountdowns[g.game_id].status === 'start' && locale.split('-')[1] === 'th'"
                                                            :class="isMobile ? 'lottery-countdown-container-bg-mobile-start mt-2' : 'lottery-countdown-container-bg-start'"
                                                            class="lottery-countdown-container">
                                                            <div class="lottery-countdown-wrapper">
                                                                <div class="flex items-center" :class="isMobile ? 'flex-col' : 'gap-1'">
                                                                    {{ $t('next') }}
                                                                    <span class="text-[10px]">{{ lotteryCountdowns[g.game_id].time }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else-if="lotteryCountdowns[g.game_id].status === 'end' && locale.split('-')[1] === 'th'"
                                                            :class="isMobile ? 'lottery-countdown-container-bg-mobile-end mt-2' : 'lottery-countdown-container-bg-end'"
                                                            class="lottery-countdown-container">
                                                            <div class="lottery-countdown-wrapper">
                                                                <div class="flex items-center gap-1">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 512 512">
                                                                        <path fill="#3bb54a" d="M464 256a208 208 0 1 1 -416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
                                                                    </svg>
                                                                    <span>{{ lotteryCountdowns[g.game_id].time }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>

                                                <img v-if="(selectedCategory !== 2 && g.new == 1)" class="game_hot" :src="`${config.public.STATIC_ROOT}img/icons/new-tag.webp`" alt="new_tag">
                                                <img v-else-if="g.hot_game == 1" class="game_hot" :src="`${config.public.STATIC_ROOT}img/icons/hot-tag.webp`" alt="hot_tag">
                                            </div>
                                            

                                                <div class="game_content flex flex-col">
                                                    <div class="game_name">{{(g.game_lang && g.game_lang[mainStore.lang]) ? g.game_lang[mainStore.lang] : g.game_name}}</div>

                                                    <div v-if="gameView === 'list' && isIBL">
                                                        <div v-if="lotteryCountdowns[g.game_id].status === 'start' && locale.split('-')[1] === 'th'"
                                                            :class="isMobile ? 'lottery-countdown-container-bg-mobile-start mt-2' : 'lottery-countdown-container-bg-start'"
                                                            class="lottery-countdown-container-list">
                                                            <div class="lottery-countdown-wrapper">
                                                                <!-- <span>{{ lotteryCountdowns[g.game_id].status === 'start' ? $t('start_in') : $t('end_in') }}</span> -->
                                                                <div class="flex items-center gap-1">
                                                                    {{ $t('next') }}
                                                                    <span>{{ lotteryCountdowns[g.game_id].time }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else-if="lotteryCountdowns[g.game_id].status === 'end' && locale.split('-')[1] === 'th'"
                                                            :class="isMobile ? 'lottery-countdown-container-bg-mobile-end mt-2' : 'lottery-countdown-container-bg-end'"
                                                            class="lottery-countdown-container-list">
                                                            <div class="lottery-countdown-wrapper">
                                                                <!-- <span>{{ lotteryCountdowns[g.game_id].status === 'start' ? $t('start_in') : $t('end_in') }}</span> -->
                                                                <div class="flex gap-1" style="align-items: stretch;">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" height="16"
                                                                        width="16" viewBox="0 0 512 512">
                                                                        <path fill="#3bb54a"
                                                                            d="M464 256a208 208 0 1 1 -416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
                                                                    </svg>
                                                                    <span>{{ lotteryCountdowns[g.game_id].time }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div @click.stop="favouriteGame(g)">
                                                    <Icon v-if="mainStore.userFavourite.list.find(obj => obj.game_id == g.game_id)" iconClass="icon-favourite"></Icon>
                                                    <Icon v-else iconClass="icon-favourite inactive"></Icon>
                                                </div>
                                                <div v-if="dashboardStore.maintenanceData[g.provider_id]" class="maintenance_box !rounded-none">
                                                <div class="maintenance_text">
                                                    <div class="maintenance_text_1" v-if="dashboardStore.maintenanceData[g.provider_id].end_date != '-'">{{ $t('maintenance_note', {start_date: dashboardStore.maintenanceData[g.provider_id].start_date, end_date: dashboardStore.maintenanceData[g.provider_id].end_date})}}</div>
                                                    <div class="maintenance_text_1" v-else>{{ $t('maintenance_note_2', {start_date: dashboardStore.maintenanceData[g.provider_id].start_date})}}</div>
                                                    <div class="maintenance_text_2">[{{g.provider_name}}]</div>
                                                </div>
                                            </div>                                     
                                            
                                        </button>
                                    </template>
                                </div>
                                <div v-else class="text-center mt-[20px] text-sm no_game_found_text_color">{{$t("no_games_found")}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="flex flex-col h-[calc(100vh-var(--offset))] supports-[height:100dvh]:h-[calc(100dvh-var(--offset))]" style="--offset:100px;">
                <div class="relative shrink-0">
                    <div class="flex items-center game-search-bg px-[5px] py-[5px]">
                        <div class="relative" style="width: calc(100% - 60px)">
                            <div class="skeleton w-full h-[35px]"></div>
                        </div>
                        <div class="flex items-center ml-[15px] w-[60px]">
                            <div class="skeleton w-full h-[35px]"></div>
                        </div>
                    </div>
                    <div class="bg-[var(--game-tab-menu-bg)] h-[43px]">
                        <div class="flex items-center overflow-x-auto">
                            <div class="skeleton w-full h-[33px]"></div>
                        </div>
                    </div>
                </div>
                <div class="flex-grow overflow-hidden relative bg-[var(--game-tab-menu-bg)]">
                    <div class="flex h-full">
                        <div class="relative" style="height: calc(100% - 40px);">
                            <div class="w-[65px] h-[20px] bg-[var(--sidebar-btn-arrow-bg)] flex items-center justify-center">
                                <svg class="w-[15px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                    <path class="game_tab_arrow" d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </div>
                            <div class="w-[65px] h-full overflow-y-auto none-scrollbar" >
                                <button v-for="i in 10" :key="i" type="button" aria-label="Sidebar" class="sidebar_button">
                                    <div class="skeleton w-full h-full"></div>
                                </button>
                            </div>
                            <div class="w-[65px] h-[20px] bg-[var(--sidebar-btn-arrow-bg)] flex items-center justify-center">
                                <svg class="w-[15px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                    <path class="game_tab_arrow" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </div>
                        </div>
                        <div class="overflow-y-auto bg-[var(--game-container-bg)] p-[5px] none-scrollbar" style="width: calc(100% - 60px);">
                            <div class="grid grid-cols-3">
                                <button v-for="i in 20" :key="i" aria-label="Tab Game" type="button" class="tab_game aspect-square">
                                    <div class="skeleton w-full h-full"></div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AppModal :show="appModal" :appModalData="appModalData" @close="appModal = false"></AppModal>
        <Modal :show="filterModal" :max-width="600" clickClose @close="filterModal = false">
            <div class="relative">
                <button @click="filterModal = false" type="button" class="btn_filter_modal_close" :aria-label="$t('close')">{{$t("close")}}</button>
                <div class="flex flex-wrap gap-2 items-center mt-4 justify-center">
                    <button @click="selectedCategory = 1; game_input = ''; filterModal = false" type="button" class="btn_filter_modal_tab" :class="selectedCategory == 1 ? 'active' : ''" :aria-label="$t('all_games')">{{$t("all_games")}}</button>
                    <button @click="selectedCategory = 2; game_input = ''; filterModal = false" type="button" class="btn_filter_modal_tab" :class="selectedCategory == 2 ? 'active' : ''" :aria-label="$t('hot_games')">{{$t("hot_games")}}</button>
                    <button @click="selectedCategory = 3; game_input = ''; filterModal = false" type="button" class="btn_filter_modal_tab" :class="selectedCategory == 3 ? 'active' : ''" :aria-label="$t('new_games')">{{$t("new_games")}}</button>
                    <button @click="selectedCategory = 4; game_input = ''; filterModal = false" type="button" class="btn_filter_modal_tab" :class="selectedCategory == 4 ? 'active' : ''" :aria-label="$t('favourite_games')">{{$t("favourite_games")}}</button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script setup>
const props = defineProps({
    type: String
});
const route = useRoute();
const config = useRuntimeConfig();
const gamesStore = useGamesStore();
const dashboardStore = useDashboardStore();
const providerStore = useProviderStore();
const localePath = useLocalePath();
const { locale, t } = useI18n()
const { $api, $toast, $setMeta, $pub, $resolveUrl } = useNuxtApp();
const router = useRouter();
const mainStore = useMainStore();
const userStore = useUserStore();
const { screenHeight, screenWidth } = useScreenHeight();
// const isIBL = ref(false);
const iblGameList = ref([]);
const countdownTrigger = ref(0);
const countdownInterval = ref(null);
const refreshLotteryInterval = ref(null);
const {isMobile} = useDevice();
const selected_index_tab = ref("ALL");
const filterModal = ref(false);
const gameView = ref("grid");

watch(gameView, (nv) => {
    localStorage.setItem('gv',nv)
})

onMounted(() => {
    const gv = window.localStorage.getItem('gv');
    if (gv) {
        gameView.value = gv;
    }
})

const isIBL = computed(() => {
    return selected_index_tab.value === 'IBL';
});

const selectedCategory = ref(1);
onMounted(() => {
    const category = window.localStorage.getItem('category');
    window.localStorage.removeItem("homeProvider")
    if (category) {
        selectedCategory.value = category;
    }
})

const gameList = ref();
const gameRefs = ref([])

onMounted(() => {
    if (route.params.provider) {
        selected_index_tab.value = route.params.provider.toUpperCase();
    }
});

watch(
    [() => gamesStore[props.type].ready, () => selected_index_tab.value],
    ([ready, currentTab]) => {
        if (!ready) return;

        // Condition: Either the page type is 'iblotto' OR the selected provider tab is 'IBL'
        const isLotteryMode = props.type === 'iblotto' || currentTab === 'IBL';

        if (isLotteryMode && locale.value.split('-')[1] === 'th') {
            // Use nextTick to ensure DOM and Store list are fully synchronized
            nextTick(() => {
                startLotteryInterval();
            });
        } else {
            // Cleanup timer if switching to a non-lottery game type/tab
            if (countdownInterval.value) {
                clearInterval(countdownInterval.value);
                countdownInterval.value = null;
            }
            iblGameList.value = [];
        }
    },
    { immediate: true }
);

const gameListKey = ref(1);
const selectProviderTab = (e, name) => {
    if (loadingScroll.value) {
        return;
    }
    if (name == selected_index_tab.value) {
        return;
    }
    gameList.value.style.overflow = 'hidden';
    game_input.value = "";
    currentPage.value = 1;
    game_input.value = "";
    searchTerm.value = "";
    currentPage.value = 1;
    selected_index_tab.value = name;
    if (gameList.value) {
        gameList.value.scrollTop = 0;
    }
    gameListKey.value++;
    route.params.provider = name;
    history.state.current = localePath(`/${props.type}/${name}`);
    history.pushState(history.state, "", localePath(`/${props.type}/${name}`));
    $setMeta()
    if (currentGameList.value.length > 0) {
        setTimeout(() => {
            calculateGameListHeight();
        }, 100);
    }
    if(name === 'IBL' && locale.value.split('-')[1] === 'th') {
        startLotteryInterval();
    }
    gameList.value.style.overflow = 'auto';
}

const startLotteryInterval = () => {
    if (locale.value.split('-')[1] !== 'th') return;
    
    // 1. Clear existing data to force a fresh state
    iblGameList.value = [];
    if (countdownInterval.value) clearInterval(countdownInterval.value);

    // 2. Safely get the list
    const currentProviderList = gamesStore[props.type]?.list[selected_index_tab.value];
    if (!currentProviderList || currentProviderList.length === 0) return;

    currentProviderList.forEach(element => {
        const startTime = element.betStartTime || element.bet_start_time;
        const endTime = element.betEndTime || element.bet_end_time;
        const drawTime = element.drawTime || element.drawtime;
        
        const startToEndInterval = new Date(endTime).getTime() - new Date(startTime).getTime();
        const endToDrawInterval = new Date(drawTime).getTime() - new Date(endTime).getTime(); 

        iblGameList.value.push({
            gameName: element.game_name,
            gameId: element.game_id,
            startTime,
            endTime,
            drawTime,
            startToEndInterval,
            endToDrawInterval
        });    
    });
    
    // 3. Restart the ticker
    countdownInterval.value = setInterval(() => {
        countdownTrigger.value++;
    }, 1000);
}

const lotteryCountdowns = computed(() => {
    if (locale.value && locale.value.split('-')[1] == 'th') {
        countdownTrigger.value;
        const countdowns = {};
        currentGameList.value.forEach(game => {
            countdowns[game.game_id] = calculateLotteryCountDown(game.game_id);
        });
        return countdowns;
    }
    return {};
})

const calculateLotteryCountDown = (id) => {
    if (locale.value.split('-')[1] !== 'th') return;
    countdownTrigger.value; 
    const game = iblGameList.value.find(g => g.gameId === id);
    const gameIndex = iblGameList.value.findIndex(g => g.gameId === id);
    
    if (!game) return { status: '', time: '', nextOpen: '' };

    let status = '';
    const now = new Date().getTime();
    const startTime = new Date(game.startTime).getTime();
    const endTime = new Date(game.endTime).getTime();
    const drawTime = new Date(game.drawTime).getTime();
    
    if (startTime == 0 || endTime == 0 || drawTime == 0) return { status: '', time: '', nextOpen: '' };

    let timeDiff = 0;
    let startDateTime = '';
    let nextOpenText = '';

    if (endTime !== drawTime) {
        if (now > startTime && now < endTime) {
            timeDiff = endTime - now;
            status = 'end';
            
            const originalStartDate = new Date(startTime);
            const nextStartDate = new Date(drawTime);
            nextStartDate.setHours(originalStartDate.getHours(), originalStartDate.getMinutes(), originalStartDate.getSeconds(), 0);
            while (nextStartDate.getTime() <= drawTime) {
                nextStartDate.setDate(nextStartDate.getDate() + 1);
            }
            startDateTime = nextStartDate;
        } else if (now > endTime) {
            const originalStartDate = new Date(startTime);
            const nextStartDate = new Date(drawTime);
            nextStartDate.setHours(originalStartDate.getHours(), originalStartDate.getMinutes(), originalStartDate.getSeconds(), 0);
            while (nextStartDate.getTime() <= drawTime) {
                nextStartDate.setDate(nextStartDate.getDate() + 1);
            }
            iblGameList.value[gameIndex].startTime = nextStartDate.getTime();
            iblGameList.value[gameIndex].endTime = nextStartDate.getTime() + game.startToEndInterval;
            iblGameList.value[gameIndex].drawTime = iblGameList.value[gameIndex].endTime + game.endToDrawInterval;
            
            startDateTime = nextStartDate;
            status = 'start';
        } else {
            startDateTime = new Date(startTime);
            status = 'start';
        }
    } else {
        let intervalMinutes = game.gameName === 'Yeekee 15 Minutes' ? 15 : 5;
        const targetDate = new Date(now);
        const minutesIntoInterval = targetDate.getMinutes() % intervalMinutes;
        const minutesToAdd = intervalMinutes - minutesIntoInterval;

        targetDate.setMinutes(targetDate.getMinutes() + minutesToAdd, 0, 0);
        timeDiff = targetDate.getTime() - now;
        status = 'end';
        startDateTime = targetDate;
    }

    // --- FORMATTING LOGIC FIX ---
    let time = '';
    if (status === 'end') {
        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

        if (props.type === 'iblotto') {
            // Long format for Image 3 (New Cards)
            const dayText = days > 0 ? `${days} ${t('day_remaining')} ` : `${t('remaining')} `;
            time = `${dayText}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } else {
            // Compact format for Image 1 (Standard IBL Overlays)
            // Just HH:mm:ss as shown in Image 1
            const totalHours = (days * 24) + hours;
            time = `${totalHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }
    }else if (status === 'start' && startDateTime !== ''){
        const day = String(startDateTime.getDate()).padStart(2, '0');
        const month = String(startDateTime.getMonth() + 1).padStart(2, '0');
        const year = startDateTime.getFullYear();
        const hours = String(startDateTime.getHours()).padStart(2, '0');
        const minutes = String(startDateTime.getMinutes()).padStart(2, '0');
        time = `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    if (startDateTime) {
        const d = String(startDateTime.getDate()).padStart(2, '0');
        const m = String(startDateTime.getMonth() + 1).padStart(2, '0');
        const y = startDateTime.getFullYear();
        const hh = String(startDateTime.getHours()).padStart(2, '0');
        const mm = String(startDateTime.getMinutes()).padStart(2, '0');
        nextOpenText = `${d}/${m}/${y} ${hh}:${mm}`;
    }

    return { status, time, nextOpen: nextOpenText };
}

const loadingScroll = ref(false);
const currentPage = ref(1);
const onScroll = (e) => {
    if (currentGameList.value.length < totalGameList.value.length) {
        const { scrollTop, offsetHeight, scrollHeight } = e.target
        if ((scrollTop + offsetHeight) >= (scrollHeight - 100)) {
            if (!loadingScroll.value) {
                loadingScroll.value = true;
                paginate(currentPage.value + 1);
                gameListKey.value++
                loadingScroll.value = false;
            }
        }
    }
}
const paginate = (e) => {
    currentPage.value = e;
}

watchEffect(() => {
	if (gameRefs.value.length > 0) {
        nextTick(() => {
            if(localStorage.getItem('lastgame')) {
                let game_hash = localStorage.getItem('lastgame')
                window.localStorage.removeItem("lastgame")
                let game_ref_index = currentGameList.value.findIndex(e => e.game_id == game_hash)
                if (game_ref_index >= 0 && gameRefs.value[game_ref_index]) {
                    setTimeout(() => {
                        gameRefs.value[game_ref_index].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
                    }, 1000)
                }
            }
        })
    }
}, {
	flush: 'post'
})

onUnmounted(() => {
    if (countdownInterval.value) {
        clearInterval(countdownInterval.value);
    }
    clearInterval(refreshLotteryInterval.value);
})

const checkImg = (e) => {
    if (e) {
        if (e.includes('https')) {
            return e;
        } else {
            return $resolveUrl(`{m}frontend/web/${e}`);
        }
    } else {
        return $pub(`/img/logo.png`);
    }
}

const getProviderLogoWhite = (p) => {
    if (p) {
        return $resolveUrl(`{d}game/provider_name/${(p.toUpperCase())}_white.webp`);
    } else {
        return $pub('/img/logo.png');
    }
}
const getProviderLogo = (p) => {
	if (p) {
		return $resolveUrl(`{d}game/provider${config.public.GAME_PROVIDER_LOGO}/${p.toUpperCase()}.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const playGame = (e) => {
    var game = {
        provider_name: e.provider_name,
        currency: dashboardStore.data.currency,
        provider_id: e.provider_id,
        game_id: e.game_id,
        maintenance: dashboardStore.maintenanceData[e.provider_id],
        category: selectedCategory.value
    }
    gamesStore.playGame(game);
}

const checkFavourite = (e) => {
    var checkGameFavourite = mainStore.userFavourite.list.find(obj => obj == e.game_id);
    if (checkGameFavourite) {
        return "favourite"
    } else {
        return ""
    }
}

const favouriteGame = async(e) => {
	if (userStore.loggedIn) {
        var checkGameFavourite = mainStore.userFavourite.list.find(obj => obj.game_id == e.game_id);
        if (checkGameFavourite) {
            mainStore.userFavourite.list = mainStore.userFavourite.list.filter(obj => obj.game_id !== e.game_id);
            gamesStore.toggleFavourite({game_id: e.game_id})

        } else {
            mainStore.userFavourite.list.push({game_id: e.game_id});
            gamesStore.toggleFavourite({game_id: e.game_id})
        }
	} else {
		mainStore.loginModal = true;
	}
}

const providerScroll = ref();
const autoProviderScroll = (e) => {
    var getProviderList = gamesStore[props.type].list;
    var propertyNames = Object.keys(getProviderList);
    const selectedProviderIndex = propertyNames.findIndex(p => p == selected_index_tab.value)
    const providerButton = document.querySelector('.sidebar_button')
    const providerButtonbuttonStyle = window.getComputedStyle(providerButton)
    const providerButtonMarginTop = parseInt(providerButtonbuttonStyle.marginTop)
    const providerButtonHeight = providerButton.clientHeight + providerButtonMarginTop
    const providerButtonOffsetHeight = selectedProviderIndex * providerButtonHeight
    nextTick(() => {
        if (providerScroll.value) {
            if (providerButtonOffsetHeight < providerScroll.value.clientHeight / 2) {
                return
            }
            providerScroll.value.scrollTop = providerButtonOffsetHeight - (providerScroll.value.clientHeight - providerButtonHeight) / 2;
        }
    })
}

const stopWatching = watchEffect(() => {
    if (gamesStore[props.type].ready && providerScroll.value) {
        nextTick(() => {
            if (gamesStore[props.type].list) {
                autoProviderScroll(route.params.provider);
            }
            stopWatching()
        })
    }
}, {
    flush: 'post'
})

let bufferTimer = null
const searchBuffer = () => {
    if (bufferTimer) {
        clearTimeout(bufferTimer)
    }
    bufferTimer = setTimeout(() => {
        handleSearch()
        clearTimeout(bufferTimer)
        bufferTimer = null
    }, 300)
}

onBeforeUnmount(() => {
    clearTimeout(bufferTimer)
    bufferTimer = null
})

const game_input = ref("");
const searchTerm = ref('')
const handleSearch = async () => {
    searchTerm.value = game_input.value
}

const wait = (miliseconds) => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, miliseconds)
    })
}

const currentGameList = computed(() => {
    gameListKey.value++
    if (totalGameList.value.length > 0) {
        if(localStorage.getItem('lastgame')) {
            let game_hash = localStorage.getItem('lastgame')
            let game_index = totalGameList.value.map(e => e.game_id).indexOf(game_hash)
            if (game_index >= 0) {
                currentPage.value = Math.ceil((game_index + 1) / 30);
            }
        }

        return totalGameList.value.slice(0, 30*currentPage.value)
    }
    return []
});
const totalGameList = computed(() => {
    if (!providerStore.ready || !gamesStore[props.type].ready) {
        return []
    }

    delete gamesStore[props.type].list.ALL;

    var obj = gamesStore[props.type].list;
    if (route.params.provider) {
        selected_index_tab.value = route.params.provider.toUpperCase();
    } else {
        selected_index_tab.value = Object.keys(obj)[0];
    }
    
    if (!gamesStore[props.type].list[selected_index_tab.value]) {
        return []
    }
    
    let allGames = []

    if (selectedCategory.value == 1) { // all games
        allGames = gamesStore[props.type].list[selected_index_tab.value]
    } else if (selectedCategory.value == 2) { // hot games
        allGames = gamesStore[props.type].list[selected_index_tab.value].filter(game => game.hot_game == 1)
    } else if (selectedCategory.value == 3) { // new games
        allGames = gamesStore[props.type].list[selected_index_tab.value].filter(game => game.new == "1")
    } else if (selectedCategory.value == 4) { // fav games
        const userFavourite = mainStore.userFavourite.list
        if(userFavourite.length > 0) {
            const recentGameIds = new Set(userFavourite.map(g => Number(g.game_id)))

            allGames = gamesStore[props.type].list[selected_index_tab.value].map((game) => {
                    return {
                        ...game,
                        recent: recentGameIds.has(game.game_id) ? 1 : 0
                    }
                }
            ).filter(game => game.recent == 1)
        }else {
            return allGames = []
        }
    } else { // favorite, temporary return empty
        return []
    }

    // filter by search term
    if (searchTerm.value) {
        allGames = allGames.filter(game => {
            let gameNameUpperCase = (game.game_lang && game.game_lang[mainStore.lang]) ? game.game_lang[mainStore.lang].toUpperCase() : game.game_name.toUpperCase()
            let searchTermUpperCase = searchTerm.value.toUpperCase()
            return gameNameUpperCase.indexOf(searchTermUpperCase) > -1
        })
    }

    // select the game for current page
    return allGames
})

const ratioInfoDisplay = computed(() => {
  const merchant = config.public.MERCHANT;
  const currency = dashboardStore.data?.currency;
  return ((merchant === 'jw8' && currency === 'IDR') || (merchant === 'champ191' && ['IDR', 'VND'].includes(currency))
  );
});

let calculateGameList = null
const current_game_list_container = ref();
const calculateGameListHeight = (e) => {
    if (currentGameList.value.length < totalGameList.value.length) {
        if (current_game_list_container.value.clientHeight < gameList.value.clientHeight) {
            if (!loadingScroll.value) {
                loadingScroll.value = true;
                paginate(currentPage.value + 1);
                gameListKey.value++
                loadingScroll.value = false;
                nextTick(() => {
                    calculateGameList = setTimeout(() => {
                        calculateGameListHeight();
                    }, 100);
                })
            }
        }
    }
}

const stopWatchingGameList = watchEffect(() => {
    if (gameList.value && current_game_list_container.value) {
        nextTick(() => {
            calculateGameListHeight();
        })
        stopWatchingGameList()
    }
}, {
    flush: 'post'
})

// APP LIST
const providerListAPP = computed(()=> {
    if (!providerStore.ready) {
        return []
    }
    var arrayAPP = providerStore.data[props.type].filter(obj => obj.mobile_status == '1');
    return arrayAPP;
})

const appModal = ref(false);
const appModalData = ref({
    provider: "",
    provider_name: "-",
    username: "-",
    password: "-",
    url: "-",
});

const openAPP = async (e) => {
    if (!userStore.loggedIn) {
        mainStore.loginModal = true;
        return
    }
    if (mainStore.loadingGame == true) {
        return;
    }
    mainStore.loadingGame = true;
    const res = await $api('mobile/mobile-login', {
        provider_id: e.id,
        currency: dashboardStore.data.currency,
    });
    if (!res.status) {
        mainStore.loadingGame = false;
        $toast(false, res.msg)
        return
    }
    appModalData.value = {
        provider: e.providerName.toUpperCase(),
        provider_name: e.display_name,
        username: res.data.username,
        password: res.data.password,
        url: res.data.url,
        play_link: res.data.play_link,
        provider_data: e,
    }

    appModal.value = true;
    mainStore.loadingGame = false;
}

const getMaintenanceStatus = (p) => {
    if (providerStore.data[props.type]) {
        var getProviderData = providerStore.data[props.type].find(obj => obj.providerName == p);
        if (getProviderData && getProviderData.id && dashboardStore.maintenanceData && dashboardStore.maintenanceData[getProviderData.id]) {
            return true;
        }
        return false;
    }
    return false;
}

const getProviderName = (p) => {
    var providerName = "";
    if (p == 'ALL') {
        providerName = "ALL"
    } else if (providerStore.data[props.type]) {
        var getProviderData = providerStore.data[props.type].find(obj => obj.providerName.toUpperCase() == p.toUpperCase());
        if (getProviderData) {
            providerName = getProviderData.fullname
        }
    }
    return providerName;
}

const getVpnStyle = computed(() => {    
    return {
         background: mainStore.vpn_tag_color,
         padding:'3px'
    }
})
</script>

<style scoped>

.sidebar_button {
    width: 65px;
    height: 65px;
    border-radius: 10px;
    background: var(--sidebar-btn2-bg);
    margin-top: 10px;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}
.sidebar_button .sidebar_button_content {
    width: 100%;
    position: relative;
    text-align: center;
}

.sidebar_button .sidebar_button_content img {
    width: 35px;
    height: 35px;
    margin: 0 auto;
    font-size: 10px;
    color: #fff;
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
}

.sidebar_button .sidebar_button_content .text {
    width: 100%;
    font-weight: 400;
    font-size: 9px;
    line-height: 11px;
    text-align: center;
    margin-top: 5px;
    text-transform: uppercase;
}

.sidebar_button .sidebar_button_content .text-iblotto {
    width: 100%;
    font-weight: 400;
    font-size: 9px;
    line-height: 11px;
    text-align: center;
    margin-top: 1px;
    text-transform: uppercase;
}
.sidebar_button.active {
    background: var(--sidebar-btn-bg-active);
    position: sticky;
    top: 0;
    bottom: 0;
    z-index: 1;
}

.tab_game {
    margin: 4px;
    position: relative;
    outline: unset;
}

.grid-cols-1 .tab_game {
    display: flex;
    width: 100%;
    margin: 5px 0px 0px 0px;
    align-items: center;
    padding: 5px;
}
.grid-cols-1 .tab_game:first-child {
    margin: 0;
}
.game_img {
    width: 100%;
    position: relative;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 5px;
}

.game_img .game_img_aspect_ratio {
    width: 100%;
    padding-top: 100%;
}

.grid-cols-1 .game_img {
    width: 50px;
}
.game_hot {
    width: 30px;
    position: absolute;
    top: 0;
    left: 0;
}
.game_content {
    margin-top: 5px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
}
.grid-cols-1 .game_content {
    width: calc(100% - 50px);
    margin-top: 0;
    padding-left: 10px;
    padding-right: 10px;
}
.game_name {
    width: calc(100% - 15px);
    font-weight: 400;
    font-size: 11px;
    text-align: left;
    word-break: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.game_flavorite {
    width: 12px;
}
.game_flavorite path {
    fill: #A8A8A8;
}

.game_flavorite.favourite path {
    fill: #ff0000;
}

.clean_search {
    width: 10px;
    height: 10px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    filter: invert(1);
}

.app_tag_mobile {
	width: 30px;
    position: absolute;
    top: -10px;
    left: -10px;
}

.provider_hot_tag_mobile {
    position: absolute;
    bottom: 0px;
    left: 0px;
}

.maintenance-tag {
    width: 20px;
    position: absolute;
    top: 5px;
    left: 5px;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    z-index: 1;
}

.ratio-info {
  color: white;
  border-radius: 9999px;
  text-align: center;
  background-color: var(--game-tab-menu-bg);
  margin-top: 2px;
}

.ratio-info.active {
  background-color: var(--category_tab_game-bg);
    font-size: 10px;
}

.ratio-info-inactive {
  font-size: 8px;
}

.provider_vpn_tag {
	width: 25px;
	position: absolute;
	top: 1px;
	right: 3px
}
.icon-favourite {
    position: absolute;
    top: 5px;
    right: 5px;
}

/* IBL Card Specific Styles */
.lottery-card-container {
    background: #222121; 
    border-radius: 6px;
    overflow: hidden; 
    display: flex;
    flex-direction: column;
    border: 1px solid #2a2a2e;
    height: 100%;
}

.lottery-card-header {
    background: #222121; 
    padding: 6px 8px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.lottery-icon-circle {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    border: 1px solid #444;
    flex-shrink: 0;
}

.lottery-title {
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.lottery-card-body {
    background: #33333C; 
    padding: 8px 6px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.lottery-timer-display {
    text-align: center;
    font-size: 10px;
    font-weight: 800;
    color: #FF0B0B; /* Red color from image */
}

.lottery-schedule-info {
    display: flex;
    gap: 4px;
    font-size: 9px;
    color: #FAFAFA;
}

.info-circle-icon {
    width: 12px;
    height: 12px;
    background: #fff;
    color: #2b2b31;
    border-radius: 50%;
    font-size: 8px;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-bet {
    width: 100%;
    background: var(--bg-main, #3bb54a); /* Fallback to green */
    color: #fff;
    font-weight: 800;
    padding: 6px;
    border-radius: 4px;
    font-size: 11px;
    margin-top: 4px;
}

.btn-registration-closed {
    width: 100%;
    background: #75757580;
    color: #222121;
    font-weight: 800;
    padding: 6px;
    border-radius: 4px;
    font-size: 10px;
    margin-top: 4px;
}

.lottery-countdown-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
}

.lottery-countdown-container {
    font-size: 12px;
    height: 2.5rem;
    border-radius: 0.5rem;
    padding-left: 0.125rem;
    padding-right: 0.125rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.lottery-countdown-container-list {
    font-size: 12px;
    height: 1.5rem;
    border-radius: 0.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

@media (max-width: 767px) {
    .lottery-countdown-container,
    .lottery-countdown-container-list {
        font-size: 9px;
    }
}

.lottery-countdown-container-bg-start {
    color: white;
    background-color: rgba(255, 255, 255, 0.3);
}

.lottery-countdown-container-bg-end {
    color: #3bb54a;
    background: #3BB54A33 0% 0% no-repeat padding-box;
}

.lottery-countdown-container-bg-mobile-start {
    color: white;
    background-color: grey;
}

.lottery-countdown-container-bg-mobile-end {
    color: #3bb54a;
    background: #3BB54A33 0% 0% no-repeat padding-box;
}

.provider_corner_badge {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 45px;
    height: 30px;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000000;
    border-bottom-right-radius: 7px;
}

.provider_corner_badge_img {
    width: auto;
    max-width: 100%;
    height: 30px;
    display: block;
    object-fit: contain;
}

.grid-cols-1 .provider_corner_badge {
    width: 24px;
    height: 18px;
    padding: 0 3px;
    border-bottom-right-radius: 5px;
}

.grid-cols-1 .provider_corner_badge_img {
    height: 16px;
}

.grid-cols-1 .game_hot {
    width: 12px;
}
.game_hot,
.tab-game-list .tab_game .game_hot {
    width: 20px;
    position: absolute;
    top: 0;
    left: auto;
    right: 5px;
}

</style>